module.exports = __webpack_public_path__ + "static/media/HanoiEx-2.6e165ce3.jpeg";